export const WA_NUMBER_1 = "917034618014";
export const WA_NUMBER_2 = "918590566268";
export const WA_DISPLAY = "70346 18014  |  85905 66268";

export const waLink = (number, message) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
export const trackEvent = (event, data = {}) => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, ...data }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // tracking must never block the user
  }
};


export const WA_BOOK_MSG =
  "Hi IQMIZE! I'd like to get the IQMIZE book (Rs 49). Please share the payment and download details.";
export const WA_GROUP_MSG =
  "Hi IQMIZE! I'm interested in the 7-Day Group Mentoring program (Rs 4,900). Please share the details.";
export const WA_INDIVIDUAL_MSG =
  "Hi IQMIZE! I'd like to enquire about the 7-Day Individual Mentoring program (Rs 19,000).";
export const WA_PAID_MSG =
  "Hi IQMIZE! I've paid Rs 49 via UPI. Here's my payment screenshot — please send me the download link.";

export const openPaymentModal = (source) => {
  trackEvent("payment_modal_open", { source });
  window.dispatchEvent(new CustomEvent("iqmize:open-payment"));
};

export const PREVIEW_PAGES = [
  { src: "/assets/preview-welcome.jpg", label: "Welcome to IQMIZE" },
  { src: "/assets/preview-1.jpg", label: "Your IQMIZE Mission" },
  { src: "/assets/preview-2.jpg", label: "How to Use This Book" },
  { src: "/assets/preview-contents.jpg", label: "Contents" },
  { src: "/assets/preview-3.jpg", label: "Parent's Guide" },
];

export const UPI_LINK =
  "upi://pay?pa=abdulazeez.pkl@oksbi&pn=IQMIZE&am=49&cu=INR&tn=IQMIZE%20Book%20Download";

export const IMAGES = {
  heroBg: "/assets/hero-bg.webp",
  hero: "/assets/book-cover.png",
  parent: "/assets/parents.png",
  exam: "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxzdHVkZW50JTIwZXhhbSUyMGZvY3VzfGVufDB8fHx8MTc5MDE0Mjk0NHww&ixlib=rb-4.1.0&q=85",
  logo: "/assets/iqmize-logo.png",
};

export const NAV_LINKS = [
  { label: "Learning Loop", href: "#learning-loop" },
  { label: "7-Day Program", href: "#seven-day" },
  { label: "For Parents", href: "#for-parents" },
  { label: "Exam Prep", href: "#exam-prep" },
  { label: "Coaching", href: "#coaching" },
];

export const WHY_POINTS = [
  "Calm the mind before learning",
  "Visualize important information",
  "Remember through active recall",
  "Practice through questions and problem-solving",
  "Perform with greater confidence",
];

export const LOOP_STEPS = [
  { title: "Learn", desc: "Understand the topic and identify the main ideas." },
  { title: "Close the Book", desc: "Stop looking at the material." },
  { title: "Recall", desc: "Ask yourself: What can I remember?" },
  { title: "Visualize", desc: "Create mental pictures, connections and memorable images." },
  { title: "Explain", desc: "Explain the concept in your own words." },
  { title: "Check", desc: "Compare your recall with the original material." },
  { title: "Correct", desc: "Identify and work on the gaps." },
  { title: "Repeat Later", desc: "Return to important material after time has passed." },
];

export const CORE_SKILLS = [
  { icon: "calm", title: "Calm", sub: "Relaxation & Concentration", desc: "Get your mind ready to learn." },
  { icon: "visualize", title: "Visualize", sub: "Mental Imagery", desc: "Turn information into pictures." },
  { icon: "remember", title: "Remember", sub: "Active Recall", desc: "Bring information back without looking." },
  { icon: "practice", title: "Practice", sub: "Testing & Problem Solving", desc: "Use questions to discover what you know." },
  { icon: "perform", title: "Perform", sub: "Mental Rehearsal & Exam Confidence", desc: "Practice answering calmly and carefully." },
];

export const PROCESS_STEPS = ["Understand", "Visualize", "Recall", "Explain", "Practice", "Correct", "Review"];

export const SEVEN_DAYS = [
  { day: 1, title: "Understand", desc: "Don't memorize what you don't understand." },
  { day: 2, title: "Retrieve", desc: "Practice bringing yesterday's learning back without looking." },
  { day: 3, title: "Connect", desc: "Build relationships between ideas." },
  { day: 4, title: "Teach", desc: "Explain what you have learned in your own words." },
  { day: 5, title: "Practice Test", desc: "Move from learning to answering." },
  { day: 6, title: "Mix It Up", desc: "Change subjects and practice retrieving different kinds of information." },
  { day: 7, title: "Consolidate", desc: "Recall, practice, correct and review before proper rest." },
];

export const STUDENT_MISSION = [
  "Stay calm and focused.",
  "Turn information into pictures and connections.",
  "Close the book and practice remembering.",
  "Explain what you know in your own words.",
  "Practice questions instead of only rereading.",
  "Review important ideas again after time has passed.",
  "Build confidence through practice.",
];

export const PARENT_ASKS = [
  "What do you remember?",
  "Can you picture it?",
  "What happened next?",
  "Can you explain it in your own words?",
];

export const EXAM_MINDSET = [
  { icon: "rhino", title: "Rhino Mind", desc: "No fear. No distraction." },
  { icon: "eagle", title: "Eagle Eyes", desc: "Read every word carefully." },
  { icon: "brain", title: "Calm Brain", desc: "Think before answering." },
  { icon: "hand", title: "Steady Hand", desc: "Write clearly." },
  { icon: "heart", title: "Confident Heart", desc: "Trust your preparation." },
];

export const EXAM_RESET = [
  "Stop",
  "Three fingers",
  "3-5 slow breaths",
  "Relax shoulders",
  "Mental screen",
  "Recall",
  "Read the question carefully",
  "Start with the question you know",
];

export const BOOK_INCLUDES = [
  "Memory and recall",
  "Focus and concentration",
  "Visualization",
  "Mental imagery",
  "Learning routines",
  "Practice testing",
  "Exam preparation",
  "Parent guidance",
  "Daily learning habits",
];

export const WHO_FOR = [
  "Study hard but struggle to recall",
  "Find it difficult to concentrate",
  "Rely heavily on rereading",
  "Want to improve their learning routine",
  "Need more practice with recall",
  "Feel nervous before examinations",
  "Want to become more independent learners",
  "Want a structured approach to studying",
];
